var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5279 7.30298C2.57279 7.35081 2.62701 7.38893 2.6872 7.41499C2.7474 7.44105 2.8123 7.45449 2.8779 7.45449C2.9435 7.45449 3.0084 7.44105 3.06859 7.41499C3.12879 7.38893 3.18301 7.35081 3.2279 7.30298L8.8479 1.68298C8.89476 1.6365 8.93196 1.5812 8.95734 1.52027C8.98273 1.45934 8.9958 1.39398 8.9958 1.32798C8.9958 1.26197 8.98273 1.19662 8.95734 1.13569C8.93196 1.07476 8.89476 1.01946 8.8479 0.972978L8.3179 0.442977C8.22443 0.351363 8.09877 0.300049 7.9679 0.300049C7.83702 0.300049 7.71136 0.351363 7.6179 0.442977L2.8779 5.18298L1.3779 3.69298C1.33301 3.64515 1.27879 3.60702 1.21859 3.58096C1.1584 3.5549 1.0935 3.54146 1.0279 3.54146C0.962303 3.54146 0.897402 3.5549 0.837204 3.58096C0.777007 3.60702 0.722789 3.64515 0.677899 3.69298L0.147899 4.22298C0.101035 4.26946 0.0638379 4.32476 0.0384536 4.38569C0.0130692 4.44662 0 4.51197 0 4.57798C0 4.64398 0.0130692 4.70934 0.0384536 4.77027C0.0638379 4.83119 0.101035 4.8865 0.147899 4.93298L2.5279 7.30298Z",
    fill: "#175FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e9691312.svg";
export { ForwardRef as ReactComponent };